import { createSlice } from "@reduxjs/toolkit";
import { extraReducers } from "./action";

const initialState = {
  items: [],
  loadingStatus: "loaded",
};

const dynamicSlice = createSlice({
  name: "dynamicPageInfo",
  initialState,
  reducers: {},
  extraReducers: extraReducers,
});

const { reducer } = dynamicSlice;

export default reducer;
